<section class="c-cover c-cover--basic t-flag-grupo-c3" id="inicio">

  <div class="c-cover__image"></div>

  <h1 class="c-cover__main-title omega">
    Sobre
  </h1>

  <div class="c-cover__content">
    <p>
      Em operação desde 2014, a <strong>Redação Nota 1000</strong> é a maior
      e melhor plataforma de prática e correção de redações do Brasil.
      Primeira ferramenta a oferecer correção de redações online, a empresa
      já atendeu mais de 700.000 alunos e cerca de 270 escolas, entre renomadas
      instituições educacionais do país.
    </p>

    <p>
      Nossa plataforma conta atualmente com mais de 350 corretores selecionados
      e treinados, além de uma equipe destacada de especialistas em redação
      e Língua Portuguesa. Dispomos também de um time dedicado de profissionais
      de atendimento, programadores, cientistas de dados e linguistas
      que desenvolvem pesquisas variadas na área de inteligência artificial
      aplicada à linguagem.
    </p>

    <p>
      Estamos sediados em São Paulo/SP e atendemos alunos e escolas em todo
      o Brasil, desde o Ensino Fundamental até o Universitário, com ênfase
      no Ensino Médio e em Pré-vestibulares/ENEM.
    </p>

    <p>
      Quer melhorar sua redação ou a dos alunos de sua escola? Conte com
      a gente. Aqui na Redação Nota 1000, <strong>todos podem escrever melhor!</strong>
    </p>
  </div>

</section>
